import { UserRound } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const KEY = "pp_fp_account";
export const getAccountPref = () => localStorage.getItem(KEY) || "all";
export const setAccountPref = (v) => localStorage.setItem(KEY, v);
export const NO_ACCOUNT = "__none__";

// Due items for the chosen account; "all" = every item grouped by account (no-account last).
export function filterByAccount(items, groups, account) {
  const acc = (i) => groups[i.group_id]?.fb_account || "";
  if (account === "all") return [...items].sort((a, b) => (acc(a) || "\uffff").localeCompare(acc(b) || "\uffff"));
  return items.filter((i) => acc(i) === (account === NO_ACCOUNT ? "" : account));
}

export default function FastPostAccountPicker({ items, groups, value, onChange, disabled }) {
  const counts = {};
  items.forEach((i) => { const a = groups[i.group_id]?.fb_account || NO_ACCOUNT; counts[a] = (counts[a] || 0) + 1; });
  const accounts = Object.keys(counts).filter((a) => a !== NO_ACCOUNT).sort();
  if (accounts.length === 0) return null;
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-indigo-500/30 bg-indigo-500/10 px-4 py-3" data-testid="fast-post-account-picker">
      <div className="flex items-center gap-2 text-sm text-indigo-100">
        <UserRound className="h-4 w-4 shrink-0" />
        <span>Post ikut akaun Facebook{disabled ? " (tukar sebelum mula)" : ""}</span>
      </div>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className="h-9 w-[220px] border-indigo-500/30 bg-background text-sm" data-testid="fast-post-account-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Semua akaun ({items.length})</SelectItem>
          {accounts.map((a) => <SelectItem key={a} value={a}>{a} ({counts[a]})</SelectItem>)}
          {counts[NO_ACCOUNT] && <SelectItem value={NO_ACCOUNT}>Tiada akaun ({counts[NO_ACCOUNT]})</SelectItem>}
        </SelectContent>
      </Select>
    </div>
  );
}
